import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = {
    navigation: [
      { to: '/', label: '首页' },
      { to: '/category/all', label: '全部漫画' },
      { to: '/category/korean', label: '韩漫专区' },
      { to: '/category/japanese', label: '日漫专区' },
      { to: '/category/chinese', label: '国漫专区' },
      { to: '/about', label: '关于我们' },
    ],
    categories: [
      { to: '/category/romance', label: '恋爱漫画' },
      { to: '/category/action', label: '热血漫画' },
      { to: '/category/fantasy', label: '奇幻漫画' },
      { to: '/category/comedy', label: '搞笑漫画' },
    ],
    support: [
      { to: '/about', label: '联系我们' },
      { to: '/about', label: '帮助中心' },
      { to: '/about', label: '版权声明' },
      { to: '/about', label: '隐私政策' },
    ],
  };

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-heading text-primary-500">香蕉文化</span>
              <span className="text-xs text-foreground-600 ml-1">漫画网</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              提供下拉式、翻页与弹窗等多种阅读模式，流畅看免费全集漫画，海量韩漫日漫国漫资源，打造极致在线阅读体验。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 hover:bg-primary-100 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-foreground-600"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 hover:bg-primary-100 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-foreground-600"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 hover:bg-primary-100 transition-colors" aria-label="QQ">
                <i className="ri-qq-line text-foreground-600"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">快速导航</h4>
            <ul className="space-y-2">
              {footerLinks.navigation.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">热门分类</h4>
            <ul className="space-y-2">
              {footerLinks.categories.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">帮助支持</h4>
            <ul className="space-y-2">
              {footerLinks.support.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-4 pt-4 border-t border-background-200/70">
              <p className="text-xs text-foreground-500">客服邮箱</p>
              <p className="text-sm text-foreground-700">support@xiangjiaowenhua.com</p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2023-2026 香蕉文化漫画网 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <p className="text-xs text-foreground-500">
            本站所有漫画均来自互联网，版权归原作者所有
          </p>
        </div>
      </div>
    </footer>
  );
}